module.exports = __webpack_public_path__ + "img/yishi23.f1a9ae83.jpg";